module.exports = __webpack_public_path__ + "img/map.df91534b.jpeg";